import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnimatePresence, motion } from 'framer-motion';
import { useMeasure } from 'react-use';
import { currentStepSelector, insuranceStepsSelector, } from '@/models/steps/selectors';
import { setStep } from '@/models/steps/setStep';
import { DISABLED_BUTTONS_TEXT_OPACITY } from '@/styles/themes/components/buttonTheme';
import { useNavigateToMainPage } from '../hooks';
import { ASIDE_NAVIGATION_PADDING, useStyles } from './styles';
export const AsideNavigation = memo(() => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const currentStep = useSelector(currentStepSelector);
    const insuranceSteps = useSelector(insuranceStepsSelector);
    const navigateToMain = useNavigateToMainPage();
    const showcaseStep = useMemo(() => ({
        formStepKey: null,
        title: 'Главная страница',
        onClick: navigateToMain,
    }), []);
    const steps = [showcaseStep, ...insuranceSteps];
    const activeStepIndex = steps.findIndex((step) => step.formStepKey === currentStep);
    const [ref, { height }] = useMeasure();
    return (_jsx("div", { className: classes.root, children: _jsx("div", { style: {
                height: height
                    ? height + ASIDE_NAVIGATION_PADDING * 2
                    : 'auto',
            }, className: classes.container, children: _jsx("aside", { className: classes.navigation, ref: ref, children: _jsx(AnimatePresence, { initial: false, children: steps.map(({ formStepKey, title, isActive, onClick }, index) => {
                        const isPastOrActive = activeStepIndex > index || isActive;
                        const isPrevActive = activeStepIndex === index - 1;
                        const hasSomePrevDisabled = steps
                            .slice(0, index)
                            .some((step) => step.isNextDisabled);
                        const isDisabled = !isPastOrActive &&
                            (!isPrevActive || hasSomePrevDisabled);
                        const onTabClick = () => {
                            if (onClick) {
                                onClick();
                                return;
                            }
                            if (formStepKey) {
                                dispatch(setStep(formStepKey));
                            }
                        };
                        return (_jsx(AsideTab, { title: title, isActive: Boolean(isActive), isDisabled: isDisabled, onClick: onTabClick }, formStepKey || title));
                    }) }) }) }) }));
});
const AsideTab = memo(({ title, isActive, isDisabled, onClick, }) => {
    const classes = useStyles();
    return (_jsxs(motion.button, { layout: true, variants: {
            visible: {
                opacity: isDisabled ? DISABLED_BUTTONS_TEXT_OPACITY : 1,
                transition: { delay: 0.05 },
            },
            hidden: {
                opacity: 0,
                transition: { duration: 0.05 },
            },
        }, initial: "hidden", animate: "visible", exit: "hidden", className: classes.tab, disabled: isDisabled, onClick: onClick, "data-active": isActive, style: { originX: '0px' }, children: [isActive && (_jsx(motion.div, { layoutId: "active", className: classes.highlighter, transition: { duration: 0.1 }, style: { originX: '0px' } })), _jsx("span", { children: title })] }, title));
});
